import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supportedLanguages } from "../i18n";
import { IconChevronDown, IconCheck } from "./icons";

/**
 * قائمة منسدلة لتبديل اللغة. بتحافظ على نفس الصفحة الحالية، بس بتغيّر بادئة اللغة في الرابط
 * (مثال: من /country/jordan لـ /en/country/jordan)
 */
export default function LanguageSwitcher({ className = "" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const currentLang = (() => {
    const seg = location.pathname.split("/")[1];
    return seg in supportedLanguages ? seg : "ar";
  })();

  // قفل القائمة لو المستخدم دوس في أي مكان تاني في الصفحة
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const switchTo = (lang) => {
    setOpen(false);
    const parts = location.pathname.split("/").filter(Boolean);
    // نشيل بادئة اللغة الحالية لو موجودة
    if (parts[0] in supportedLanguages) parts.shift();
    const rest = parts.join("/");
    const prefix = lang === "ar" ? "" : `/${lang}`;
    navigate(`${prefix}/${rest}`.replace(/\/+$/, "") || "/");
  };

  return (
    <div className={`relative ${className}`} ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-bold text-gray-600 hover:bg-gray-100 transition-colors"
      >
        <span>{supportedLanguages[currentLang].label}</span>
        <IconChevronDown width={14} height={14} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute end-0 mt-1.5 w-40 bg-white rounded-xl shadow-lg border border-gray-100 py-1.5 z-50">
          {Object.entries(supportedLanguages).map(([code, cfg]) => (
            <button
              key={code}
              onClick={() => switchTo(code)}
              className={`w-full flex items-center justify-between px-4 py-2 text-sm font-bold transition-colors ${
                currentLang === code ? "text-primary-600 bg-primary-50" : "text-gray-600 hover:bg-gray-50"
              }`}
            >
              <span>{cfg.label}</span>
              {currentLang === code && <IconCheck width={16} height={16} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
